export const toFacetMap = (facets?: Readonly<(string | undefined)[]>) =>
  new Map(
    facets?.filter(Boolean).map((str) =>
      str!
        .split(':')
        .reverse()
        .map((str) => str.trim()),
    ) as [string, string][],
  )
